import React, { FC } from 'react';
import { AlertDialog } from '@/components/ui/alert-dialog';
import { DELETE_CONFIRM_LABELS } from '../NewVerificationTab.constants';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  type: 'row' | 'accountSection';
  id: string;
}

export const DeleteConfirmDialog: FC<DeleteConfirmDialogProps> = ({ isOpen, onOpenChange, onConfirm, onCancel, type, id }) => {
  const isRow = type === 'row';
  const title = isRow ? DELETE_CONFIRM_LABELS.ROW_TITLE : DELETE_CONFIRM_LABELS.ACCOUNT_SECTION_TITLE;
  const description = isRow ? DELETE_CONFIRM_LABELS.ROW_DESCRIPTION : DELETE_CONFIRM_LABELS.ACCOUNT_SECTION_DESCRIPTION;

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={onOpenChange}
      id={id}
      title={title}
      description={description}
      primaryButton={{
        label: DELETE_CONFIRM_LABELS.DELETE,
        onClick: onConfirm,
        className: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      }}
      secondaryButton={{
        label: DELETE_CONFIRM_LABELS.CANCEL,
        onClick: onCancel,
      }}
      onCancel={onCancel}
    />
  );
};
